// Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBar from './topbar';
import SideBar from './sidebar';
import "./layout.css"
import Footer from './footer';

const Layout = () => {
  return (
    <div className='main' style={{background:"rgb(247, 248, 249)"}}>
        <div className='d-flex'>
            <div style={{width:240,alignItems:'center'}}>
            <SideBar />
            </div>
            <div className='w-100'>
                <TopBar />    
                <div className='outlet-container' style={{height:615,overflow:'scroll'}}>
                  <Outlet />
                </div>
                <Footer />
            </div>
        </div>
         
    </div>
  );
};

export default Layout;
